<div class="header-menu-icon notifications">
  <div class="bueno-navbar-item">
    <a
      (mouseenter)="toggleMenu($event, true)"
      (mouseleave)="toggleMenu($event, false)"
      (click)="toggleMenu($event, true)"
      class="bueno-navbar-link is-flex is-align-items-center"
      click-outside
      (outsideClick)="closeMenu()">
      <mat-icon class="header-icon" svgIcon="bueno-bell"></mat-icon>
      @if (unreadNotificationsCount > 0) {
      <span class="notification-badge">{{ unreadNotificationsCount }}</span>
      }
      <div
        [ngClass]="{'is-active': menuActive, 'is-hidden': !menuActive}"
        class="bueno-navbar-dropdown notifications-menu">
        <!-- <div [ngClass]="{'is-active': true, 'is-hidden': false}" class="bueno-navbar-dropdown notifications-menu"> -->
        <div class="notifications-header">
          <p class="font-subtitle">{{'NOTIFICATIONS.TITLE'|translate}}</p>
          @if (notifications.length > 0) {
          <div class="notifications-actions">
            <button class="notifications-action" (click)="markAllNotificationsRead(); $event.stopPropagation()">
              {{'NOTIFICATIONS.MARK_ALL_READ'|translate}}
            </button>
          </div>
          }
        </div>

        @if (notificationPermission === 'default') {
        <div class="notifications-permission">
          <app-button-primary
            size="small-btn"
            class="notifications-enable"
            (onClick)="enableNotifications(); $event.stopPropagation()">
            {{'NOTIFICATIONS.enable_notifications'|translate}}
          </app-button-primary>
        </div>
        } @else if (notificationPermission === 'denied') {
        <div class="notifications-permission blocked">
          <p class="font-subtitle">{{'NOTIFICATIONS.PERMISSION_BLOCKED'|translate}}</p>
        </div>
        }

        <div class="notifications-list scroll-style">
          @if (notifications.length === 0) {
          <p class="notifications-empty font-subtitle">{{'NOTIFICATIONS.EMPTY'|translate}}</p>
          } @else { @for (notification of notifications; track notification.id) {
          <div class="notification-item" [ngClass]="{ 'is-unread': !notification.read }">
            <button
              class="notification-main"
              type="button"
              (click)="handleNotificationClick(notification); $event.stopPropagation()">
              <div class="notification-header">
                <p class="notification-title">{{ notification.title }}</p>
                <span class="notification-time">{{ notification.receivedAt | date:'short' }}</span>
              </div>
              @if (notification.body) {
              <p class="notification-body">{{ notification.body }}</p>
              }
            </button>
            <button
              class="notification-remove"
              type="button"
              (click)="removeNotification(notification.id, $event)"
              [attr.aria-label]="'DELETE' | translate">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          }
          <button class="notifications-action" (click)="removeAllNotifications($event)">
            {{'NOTIFICATIONS.REMOVE_ALL'|translate}}</button
          >}
        </div>
        <!-- 
        <a
          class="notifications-settings font-subtitle"
          routerLink="/account/notifications"
          (click)="closeMenu(); $event.stopPropagation()">
          {{'NOTIFICATIONS.VIEW_SETTINGS'|translate}}
        </a> -->
      </div>
    </a>
  </div>
</div>
